export const TILESAPI_BASE_URL = 'https://tiles.fastmap.ai';
// export const TILESAPI_BASE_URL = 'http://0.0.0.0';

export const ADMINAPI_BASE_URL = 'https://admin.fastmap.ai';
// export const ADMINAPI_BASE_URL = 'http://0.0.0.0:8000';

export const GEOAIAPI_BASE_URL = 'https://geoai.fastmap.ai';
// export const GEOAIAPI_BASE_URL = 'http://0.0.0.0:85';